import React, { useEffect, useState } from 'react';
import { Box, Fade } from '@material-ui/core';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import { isSuccessState } from 'globals/utils';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { observer } from 'mobx-react';
import BillingInfoModal from '../BillingsModals/BillingInfoModal';
import {
  ActionButton,
  ButtonWrapperBox,
  Paragraph,
} from './BillingInfo.style-elements';

const BillingInfo: React.FC = () => {
  const {
    billingInfo: { status, getBillingDetailsSnapshot, init: initStore },
  } = useAppContext();
  const {
    recipientName,
    address,
    city,
    postCode,
    vat,
  } = getBillingDetailsSnapshot();
  const [showModal, setShowModal] = useState<boolean>(false);
  const fullAddress = [recipientName, address, `${city} ${postCode}`];

  useEffect(() => {
    initStore();
  }, [initStore]);

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );

  return (
    <>
      <Fade in timeout={1300}>
        <FsPaper title={defaultLocales.billingInfo}>
          <Box marginBottom={2}>
            {fullAddress.map((p) => (
              <Paragraph key={p}>{p}</Paragraph>
            ))}
          </Box>
          <Box>
            <Paragraph>
              {defaultLocales.vatNumber}: {vat}
            </Paragraph>
          </Box>
          <ButtonWrapperBox>
            <ActionButton onClick={() => setShowModal(true)}>
              {defaultLocales.update}
            </ActionButton>
          </ButtonWrapperBox>
        </FsPaper>
      </Fade>

      <BillingInfoModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default observer(BillingInfo);
